import { Component, Input, TemplateRef, ViewChild, inject } from "@angular/core";
import { NgClass } from "@angular/common";
import { ItemLinkableBase } from "@app/shared/linkable/item-linkable-base";
import { FormLinkableModule } from "@app/forms/enums/FormLinkableModule";
import { Form } from "@app/forms/models";
import { Observable, of } from "rxjs";
import { LinkableIconConfig } from "@app/shared/models/Linkable/LinkableIconConfig";
import { FormsLinkModel } from "@app/forms/models/other/FormsLinkModel";
import { nameof } from "@methods/jeffs-toolkit";
import { TabService } from "@services/tabs/TabService";
import { Pages } from "@constants/pages/Pages";
import { TranslatePipe, injectTranslation, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/forms/i18n/scope";
import { LinkableComponent } from "@app/shared/linkable/linkable.component";

@Component({
    selector: "form-linkable",
    templateUrl: "./form-linkable.component.html",
    styleUrls: ["../overview/form-overview/form-overview.component.scss"],
    imports: [NgClass, TranslatePipe, LinkableComponent],
    viewProviders: [provideTranslationScope(scope)],
})
export class FormLinkableComponent extends ItemLinkableBase {
    @Input() parentGuid: string;
    @Input() linkedModule: FormLinkableModule;
    @Input() displayValueProp: string;
    @Input() linked: FormsLinkModel[];
    @Input() unlinked: FormsLinkModel[];
    @Input() linkedForms: Form[];
    @Input() disabled: boolean = false;
    @Input() hideActions: boolean = false;
    @Input() hideFilter: boolean = false;
    @Input() allowAddNew: boolean = false;

    @ViewChild("linkTemplate") linkTemplate: TemplateRef<any>;

    showOverview: boolean = true;
    cleanSpacers: boolean = true;

    rowIconConfig: LinkableIconConfig[] = [
        {
            icon: "fas fa-circle green",
            actionColumn: nameof<FormsLinkModel>((c) => c.isActive),
            actionValue: true,
        },
        {
            icon: "fas fa-circle red",
            actionColumn: nameof<FormsLinkModel>((c) => c.isActive),
            actionValue: false,
        },
    ];

    private _tabService = inject(TabService);
    private _pages = inject(Pages);
    private _translation = injectTranslation(scope);

    openLinkPopup() {
        this._promptService
            .prompt({
                maxWidth: 1200,
                maxHeight: 800,
                data: {
                    customTemplate: this.linkTemplate,
                    cancelButton: {
                        show: false,
                    },
                    confirmButton: {
                        uiid: "button-confirm-popup",
                    },
                    closeOnEsc: false,
                    confirmOnEnter: false,
                },
            })
            .onConfirm()
            .subscribe(() => {
                this.linkedChange.emit(this.linked);
            });
    }

    protected async openForm(formLink: FormsLinkModel): Promise<void> {
        if (!formLink.hasAccess) {
            return;
        }

        await this._translation.ready();

        this._tabService.generateTab(
            this._pages.FormResults,
            formLink.id,
            this._translation.t("formLinkable.resultsTabName")
        );
    }

    hasAccessToItem(): Observable<boolean> {
        return of(false);
    }

    openTab(): void {}
}
